import React, { Suspense, lazy } from "react";
import BigLoader from "../Skeleton/BigLoader";

export const LazyComponent = (dynamicImport) => {
  const Component = lazy(dynamicImport);
  Component.preLoad = dynamicImport;
  return Component;
};

export const LazyComponentWithSuspense = (dynamicImport) => {
  const Component = lazy(dynamicImport);
  
  return (props) => (
    <Suspense fallback={<BigLoader />}>
      <Component {...props} />
    </Suspense>
  );
};
